// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fa99c400","751":"2f955bb0","780":"1c16e129","822":"f555a86f","827":"e6e7a5e9","831":"44bb846c","906":"2ff76afa","972":"a7582b17"}[chunkId] + ".chunk.js";
};